import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/software/banner.png'


const _hoisted_1 = {
  key: 0,
  class: "software"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "nav-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "product-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "image" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "intro" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "zh-title" }
const _hoisted_13 = { class: "en-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyHeader = _resolveComponent("MyHeader")!
  const _component_CommonFooter = _resolveComponent("CommonFooter")!
  const _component_DetailPage = _resolveComponent("DetailPage")!

  return (_ctx.view === 'list')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MyHeader, { currentMenuIndex: 3 }),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"banner\" data-v-cd81ece2><img src=\"" + _imports_0 + "\" alt=\"\" data-v-cd81ece2><div class=\"text\" data-v-cd81ece2><div class=\"text-zh\" data-v-cd81ece2><span data-v-cd81ece2>自主研发</span><div class=\"dot\" data-v-cd81ece2></div><span data-v-cd81ece2>智能一体化系统</span></div><div class=\"text-en\" data-v-cd81ece2><div class=\"line\" data-v-cd81ece2></div><span data-v-cd81ece2>Intelligent integrated system</span><div class=\"line\" data-v-cd81ece2></div></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.currnetNavIndex === index ? 'nav-item active-item' : 'nav-item'),
                key: index,
                onClick: ($event: any) => (_ctx.currnetNavIndex = index)
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item), 1)
              ], 10, _hoisted_4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "product-item",
                key: index,
                onClick: ($event: any) => (_ctx.jumpProductDetail(item.key))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: ""
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(item.zhName), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.enName), 1)
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon" }, [
                    _createElementVNode("div", { class: "icon-list" }, [
                      _createElementVNode("i", {
                        class: "iconfont iconyoujiantou",
                        style: {"font-size":"12px","color":"#C8C8C8"}
                      }),
                      _createElementVNode("i", {
                        class: "iconfont iconyoujiantou",
                        style: {"font-size":"12px","color":"#C8C8C8"}
                      })
                    ])
                  ], -1))
                ])
              ], 8, _hoisted_7))
            }), 128))
          ])
        ]),
        _createVNode(_component_CommonFooter)
      ]))
    : (_openBlock(), _createBlock(_component_DetailPage, {
        key: 1,
        onReturnList: _ctx.returnList
      }, null, 8, ["onReturnList"]))
}